import {WPApi} from "../common/wp-api";

const api = new WPApi();

let loaded = {};


jQuery(document).ready(($) => {
    $('.sport1-widget').each(function () {
        let widgetId = $(this).attr('id');
        let $widget = $(`#${widgetId}`);

        let intersectionObserver = new IntersectionObserver(async (entries) => {
            // If the browser is busy while scrolling happens, multiple entries can
            // accumulate between invocations of this callback. As long as any one
            // of the notifications reports the sentinel within the scrolling viewport,
            // we add more content.
            if (entries.some(entry => {
                let widgetId = $(entry.target).attr('id');
                return entry.intersectionRatio > 0 &&
                    !loaded[widgetId]
            })) {

                let visibleEntries = entries.filter(entry => entry.intersectionRatio > 0);

                for (const entry of visibleEntries) {
                    let widgetId = $(entry.target).attr('id');
                    loaded[widgetId] = true;
                    intersectionObserver.unobserve(entry.target);
                    await load(widgetId);
                }

            }
        });

        intersectionObserver.observe($widget.get(0));
    });
})


async function load(widgetId) {
    try {
        let category = pageGlobals.globalCategory ? pageGlobals.globalCategory : pageGlobals.post.category;
        let widgetContent = await api.get(`sport1/v1/widgets/${widgetId}?category_id=${category}`);
        jQuery(`#${widgetId} .widget-content`).html(widgetContent);
        lazyLoader.update();

        jQuery(`#${widgetId}`).get(0).dispatchEvent(new Event('sport1WidgetLoaded'));

    } catch (e) {
        console.error(e);
    }
}


